export default __webpack_public_path__ + "static/img-finish-products-d5802987953878cc1fd95f5473af20f3.webp";